import validate from '../../../services/reduxValidate.js'

export default function(data) {
  const validators = {
    'freelance.fonctions': {
      length: {
        maximum: 5,
        minimum: 0,
        tooLong: 'Vous devez saisir au maximum 5 éléments',
        tooShort: 'Vous devez encore saisir 1 élément'
      },
    },
    'freelance.master_skills': {
      length: {
        maximum: 8,
        minimum: 0,
        tooLong: 'Vous devez saisir au maximum 8 éléments',
        tooShort: 'Vous devez encore saisir 1 élément'
      },
    },
    'freelance.expertises': {
      length: {
        maximum: 10,
        minimum: 0,
        tooLong: 'Vous devez saisir au maximum 10 éléments',
        tooShort: 'Vous devez encore saisir 1 élément'
      },
    },
  }

  return validate(data, validators)
}
